module.exports = __webpack_public_path__ + "static/media/AdmisionesUrgentes.cced5b59.svg";